"use strict";
      var defaultOptions = function(e) {
          return (
            (e = "number" == typeof e ? { precision: e } : e || {}),
            (e.precision = e.precision || 5),
            (e.factor = e.factor || Math.pow(10, e.precision)),
            (e.dimension = e.dimension || 2),
            e
          );
        },
   MyPolylineUtil = {
          encode: function(e, n) {
            n = defaultOptions(n);
            for (var t = [], r = 0, o = e.length; o > r; ++r) {
              var i = e[r];
              if (2 === n.dimension)
                t.push(i.lat || i[0]), t.push(i.lng || i[1]);
              else for (var d = 0; d < n.dimension; ++d) t.push(i[d]);
            }
            return this.encodeDeltas(t, n);
          },
          decode: function(e, n) {
            n = defaultOptions(n);
            for (
              var t = this.decodeDeltas(e, n), r = [], o = 0, i = t.length;
              o + (n.dimension - 1) < i;

            ) {
              for (var d = [], s = 0; s < n.dimension; ++s) d.push(t[o++]);
              r.push(d);
            }
            return r;
          },
          encodeDeltas: function(e, n) {
            n = defaultOptions(n);
            for (var t = [], r = 0, o = e.length; o > r; )
              for (var i = 0; i < n.dimension; ++i, ++r) {
                var d = e[r],
                  s = d - (t[i] || 0);
                (t[i] = d), (e[r] = s);
              }
            return this.encodeFloats(e, n);
          },
          decodeDeltas: function(e, n) {
            n = defaultOptions(n);
            for (
              var t = [], r = this.decodeFloats(e, n), o = 0, i = r.length;
              i > o;

            )
              for (var d = 0; d < n.dimension; ++d, ++o)
                r[o] =
                  Math.round((t[d] = r[o] + (t[d] || 0)) * n.factor) / n.factor;
            return r;
          },
          encodeFloats: function(e, n) {
            n = defaultOptions(n);
            for (var t = 0, r = e.length; r > t; ++t)
              e[t] = Math.round(e[t] * n.factor);
            return this.encodeSignedIntegers(e);
          },
          decodeFloats: function(e, n) {
            n = defaultOptions(n);
            for (
              var t = this.decodeSignedIntegers(e), r = 0, o = t.length;
              o > r;
              ++r
            )
              t[r] /= n.factor;
            return t;
          },
          encodeSignedIntegers: function(e) {
            for (var n = 0, t = e.length; t > n; ++n) {
              var r = e[n];
              e[n] = 0 > r ? ~(r << 1) : r << 1;
            }
            return this.encodeUnsignedIntegers(e);
          },
          decodeSignedIntegers: function(e) {
            for (
              var n = this.decodeUnsignedIntegers(e), t = 0, r = n.length;
              r > t;
              ++t
            ) {
              var o = n[t];
              n[t] = 1 & o ? ~(o >> 1) : o >> 1;
            }
            return n;
          },
          encodeUnsignedIntegers: function(e) {
            for (var n = "", t = 0, r = e.length; r > t; ++t)
              n += this.encodeUnsignedInteger(e[t]);
            return n;
          },
          decodeUnsignedIntegers: function(e) {
            for (var n = [], t = 0, r = 0, o = 0, i = e.length; i > o; ++o) {
              var d = e.charCodeAt(o) - 63;
              (t |= (31 & d) << r),
                32 > d ? (n.push(t), (t = 0), (r = 0)) : (r += 5);
            }
            return n;
          },
          encodeSignedInteger: function(e) {
            return (
              (e = 0 > e ? ~(e << 1) : e << 1), this.encodeUnsignedInteger(e)
            );
          },
          encodeUnsignedInteger: function(e) {
            for (var n, t = ""; e >= 32; )
              (n = (32 | (31 & e)) + 63),
                (t += String.fromCharCode(n)),
                (e >>= 5);
            return (n = e + 63), (t += String.fromCharCode(n));
          }
        };
